<template>
  <div>
    <div class="flex-center">
      <div class="text-center" style="width: 50%">
        <div style="margin-bottom: 10px;">二寸照片</div>
        <img :src="form.officialPhoto2" alt="" style="width: 200px;">
      </div>
      <div class="text-center" style="width: 50%">
        <div style="margin-bottom: 10px;">上传照片</div>
        <img :src="form.currentPhoto2" alt="" style="width: 200px;">
      </div>
    </div>
    <div class="text-right" style="margin-top: 50px;">
      <el-button size="medium" @click="$emit('close', false)">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'jury-edit',
  components: {},
  props: ['row'],
  data () {
    return {
      form: {}
    }
  },
  async created () {
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async initForm () {
      if (this.row) {
        // let info = await this.$HTTP.ApiFaceCertify.getInfo(this.row.logId)
        this.row.currentPhoto2 = await this.$HTTP.ApiOss.signatureUrl(this.row.currentPhoto, 'ID-photo')
        this.row.officialPhoto2 = await this.$HTTP.ApiOss.signatureUrl(this.row.officialPhoto, 'ID-photo')
        this.form = this.row
      }
    }
  }
}
</script>
